<cs-header>
  <cs-header-title>
    {{ LL.progress.title() }}
    <cs-header-title-action>
      <cs-icon-button icon="settings" (click)="handleSettingsClick($event)"></cs-icon-button>
    </cs-header-title-action>
  </cs-header-title>
</cs-header>

<cs-content>
  <div class="progress-content">

    <!-- Date Range Toolbar -->
    <cs-date-range-toolbar
      [timePeriod]="timePeriod"
      [periodSet]="timePeriodSet"
      [earliestDataDate]="earliestDataDate"
      (dateRangeChange)="handleDateRangeChange($event)">
    </cs-date-range-toolbar>

    <!-- Body Composition overview (#5456), only while the coaching dashboard switch is on -->
    @if (coachingDashboardOn) {
      <cs-body-comp-overview
        [model]="overviewModel"
        [loading]="overviewLoading"
        [failed]="overviewFailed"
        (retry)="loadOverviewAsync()">
      </cs-body-comp-overview>
    }

    <!-- Chart Card -->
    <cs-card>
      <cs-card-title class="with-button">
        {{ chartTitle }}
        <cs-button secondary small icon="tune" (click)="handleFilterButtonClick($event)"
          [class.active]="activeFilterCount > 0">
          {{ LL.progress.filters() }} ({{ activeFilterCount }})
        </cs-button>
      </cs-card-title>
      <cs-card-content>
        <cs-progress-chart
          [series]="chartSeries"
          [data]="chartData"
          [axisConfig]="chartAxisConfig"
          [timePeriod]="timePeriod"
          [startDate]="startDate?.toISODate()"
          [endDate]="endDate?.toISODate()"
          [showAvg]="showAvg"
          [showPoints]="filters.showPoints"
          [trends]="chartTrends"
          [isLoading]="chartLoading">
        </cs-progress-chart>
      </cs-card-content>
    </cs-card>

    <!-- Measurements Card -->
    <cs-card>
      <cs-card-title>{{ LL.progress.measurements() }}</cs-card-title>
      <cs-card-content>
        <div class="measurements-grid">
          <!-- Measurement template definition -->
          <ng-template #measurementItemTemplate let-measurement="measurement" let-label="label" let-show="show">
            @if (show) {
              <div class="measurement-item">
                <div class="measurement-label">{{ label }}</div>
                <div class="measurement-body">
                  <div class="measurement-value">
                    @if (measurement?.hasData) {
                      <span class="current-value">{{ measurement.currentValue }}</span>
                    }
                    @if (!measurement?.hasData) {
                      <span class="current-value">{{ LL.progress.noData() }}</span>
                    }
                    @if (measurement?.hasData) {
                      <span class="change-text" [style.--change-color]="'var(' + measurement.colorVar + ')'">
                        ({{ measurement.totalChange }})
                        <cs-icon [name]="measurement.trendIcon"></cs-icon>
                      </span>
                    }
                  </div>
                  @if (measurement?.hasData) {
                    <div class="measurement-change" [style.--change-color]="'var(' + measurement.colorVar + ')'">
                      <span class="change-value">{{ measurement.avgChangePerWeek }}</span>
                      <span class="change-label">{{ measurement.changeText }}</span>
                    </div>
                  }
                </div>
              </div>
            }
          </ng-template>

          <!-- Use template for each measurement -->
          <ng-container *ngTemplateOutlet="measurementItemTemplate; context: {
            measurement: weightMeasurement,
            label: LL.common.measurements.weight(),
            show: filters.weight
          }"></ng-container>

          <ng-container *ngTemplateOutlet="measurementItemTemplate; context: {
            measurement: skinfoldMeasurement,
            label: LL.common.measurements.skinfolds(),
            show: filters.skinfolds
          }"></ng-container>

          <ng-container *ngTemplateOutlet="measurementItemTemplate; context: {
            measurement: waistMeasurement,
            label: LL.common.measurements.waist(),
            show: filters.waist
          }"></ng-container>
        </div>
      </cs-card-content>
    </cs-card>

  </div>
</cs-content>